export var VALIDATION_ERROR_CODES;
(function (VALIDATION_ERROR_CODES) {
    VALIDATION_ERROR_CODES["InvalidFileDimensions"] = "INVALID_FILE_DIMENSIONS";
    VALIDATION_ERROR_CODES["InvalidFileSize"] = "INVALID_FILE_SIZE";
    VALIDATION_ERROR_CODES["InvalidUrlFormat"] = "INVALID_URL_FORMAT";
    VALIDATION_ERROR_CODES["InvalidFileFormat"] = "INVALID_FILE_FORMAT";
})(VALIDATION_ERROR_CODES || (VALIDATION_ERROR_CODES = {}));
export var UPLOAD_ERROR_CODES;
(function (UPLOAD_ERROR_CODES) {
    UPLOAD_ERROR_CODES["MissingSource"] = "MISSING_SOURCE";
    UPLOAD_ERROR_CODES["ProviderNotFound"] = "PROVIDER_NOT_FOUND";
    UPLOAD_ERROR_CODES["ProviderNotAllowed"] = "PROVIDER_NOT_ALLOWED";
    UPLOAD_ERROR_CODES["MissingAuthToken"] = "MISSING_AUTH_TOKEN";
})(UPLOAD_ERROR_CODES || (UPLOAD_ERROR_CODES = {}));
//# sourceMappingURL=upload.js.map